// extracted by mini-css-extract-plugin
export default {"main":"main_main__kLTtw","main_title":"main_main_title__PwBVM"};